import { ButtonModule } from '@wuitk/angular/components/button';
import { ClickOutsideModule } from 'ng-click-outside';
import { CommonModule as WuitkCommonModule } from '@wuitk/angular/components/common';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { StoreModule } from '@ngrx/store';
import { COMPONENTS, COMPONENTS_EXPORTS, SERVICES } from './index';
import { CoreModule } from '../../core/core.module';
import { MenuModule } from '@wuitk/angular/components/menu';
import { SharedModule } from '@ispm/shared/shared.module';
import { navigationReducer } from './store/navigation.reducer';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    WuitkCommonModule,
    CoreModule,
    ButtonModule,
    StoreModule.forFeature('navigation', navigationReducer),
    SharedModule,
    MenuModule,
    OverlayPanelModule,
    ClickOutsideModule,
        MatMenuModule
  ],
  declarations: [...COMPONENTS],
  providers: [...SERVICES],
  exports: [...COMPONENTS_EXPORTS]
})
export class NavigationModule { }

